
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ScrBaseComponent } from "src/app/components/base.component";
import { ConfirmationService } from 'primeng/api';


@Component({
  selector: 'app-intended-usage',
  templateUrl: './intended-usage.component.html',
  styleUrls: ['./intended-usage.component.scss']
})

export class IntendedUsageComponent extends ScrBaseComponent implements OnInit {

  @Input() largeHeadingSize = false;
  @Input() colWidth = 'col-6';
  
  private _codeType = 'active';
  @Input() usagesEnabled: string[] = ['active', 'parked', 'demo'];

  public selectedCodeType!: string;

  @Output() update = new EventEmitter<string>();

  constructor(
    private confirmationService: ConfirmationService
  ) {
    super();
  }

  get codeType(): string {
    return this._codeType;
  }

  @Input() set codeType(v: string) {
    this._codeType = v;
    if (!this.selectedCodeType) {
      this.selectedCodeType = v;
    }
  }

  ngOnInit(): void {
    this.selectedCodeType = this._codeType;
    // console.debug('usages is ' + this.usagesEnabled);
  }

  setCodeType(): void {
    if (this.codeType === 'active') {
      this.selectedCodeType = this._codeType;
      this.update.emit(this._codeType);
    }
    else if (this.usagesEnabled.includes('all')) {
      // if we're not in a ordering or editing flow, just set it.
      this.selectedCodeType = this._codeType;
      this.update.emit(this._codeType);
    }
    else {
      const key = 'scr.confirmParkedOrDemo';
      const message = this.translate.instant(key);
      this.confirmationService.confirm({
        key: 'confirmDemoCodes',
        header: this.translate.instant('scr.confirmParkedOrDemo.title'),
        message,

        accept: () => {
          this.update.emit(this._codeType);
          this.selectedCodeType = this._codeType;
        },
        reject: () => {
          // debugging for automation...
          console.debug('reject so set value back to ' + this.selectedCodeType);
          // restore the previous value.
          this._codeType = this.selectedCodeType;
          console.debug('codeType restored to ' + this.selectedCodeType);
          this.update.emit(this._codeType);
        }
      });
    }
  }
}
